import React, { createContext, useState, useEffect } from 'react';
import { getFirestore, doc, setDoc, getDoc } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { db } from './../../firebase/firebaseConfig';

export const FavoriteContext = createContext();

export const FavoriteProvider = ({ children }) => {
    const [favorites, setFavorites] = useState([]);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            if (currentUser) {
                fetchFavorites(currentUser.uid);
            } else {
                const storedFavorites = JSON.parse(sessionStorage.getItem('favorites')) || [];
                setFavorites(storedFavorites);
            }
        });
        return () => unsubscribe();
    }, []);

    const fetchFavorites = async (userId) => {
        const docRef = doc(db, 'users', userId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            setFavorites(docSnap.data().favorites || []);
        }
    };

    const addFavorite = async (product) => {
        const updatedFavorites = [...favorites, product];
        setFavorites(updatedFavorites);

        if (user) {
            const userRef = doc(db, 'users', user.uid);
            await setDoc(userRef, { favorites: updatedFavorites }, { merge: true });
        } else {
            sessionStorage.setItem('favorites', JSON.stringify(updatedFavorites));
        }
    };

    const removeFavorite = async (productId) => {
        const updatedFavorites = favorites.filter(item => item.id !== productId);
        setFavorites(updatedFavorites);

        if (user) {
            const userRef = doc(db, 'users', user.uid);
            await setDoc(userRef, { favorites: updatedFavorites }, { merge: true });
        } else {
            sessionStorage.setItem('favorites', JSON.stringify(updatedFavorites));
        }
    };

    return (
        <FavoriteContext.Provider value={{ favorites, addFavorite, removeFavorite }}>
            {children}
        </FavoriteContext.Provider>
    );
};
